"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkipLinks = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactUid = require("react-uid");
var _useTheme = require("../../../theme/utils/useTheme");
var _SkipLinkButton = require("../styled/SkipLinkButton");
var _SkipLinkContainer = require("../styled/SkipLinkContainer");
const SkipLinks = _ref => {
  let {
    links
  } = _ref;
  const [isFocused, setIsFocused] = (0, _react.useState)(false);
  const theme = (0, _useTheme.useTheme)();
  const onFocus = () => {
    setIsFocused(true);
  };
  const onBlur = () => {
    setIsFocused(false);
  };
  return /*#__PURE__*/_react.default.createElement(_SkipLinkContainer.SkipLinkContainer, {
    orientation: "row",
    space: theme.skipLink.container.gap,
    onFocus: onFocus,
    onBlur: onBlur,
    isFocused: isFocused,
    theme: theme
  }, links.map(link => {
    const {
      "aria-label": ariaLabel,
      content,
      to
    } = link;
    const execute = () => {
      const targetElement = to();
      if (process.env.NODE_ENV !== "production") {
        if (!targetElement) {
          console.error("No target element found for this skip link. This element must be present to focus it.");
        } else {
          const tabIndex = targetElement.getAttribute("tabindex") || "undefined";
          if (tabIndex !== "-1") {
            console.error(`The target element for this skip link doesn't have a tabindex set to -1 (found: "${tabIndex}"). This is required to work around some browser quirks.`);
          }
        }
      }
      targetElement?.focus();
    };
    return /*#__PURE__*/_react.default.createElement(_SkipLinkButton.SkipLinkButton, {
      "aria-label": ariaLabel,
      key: (0, _reactUid.uid)(link),
      onClick: execute,
      theme: theme
    }, content);
  }));
};
exports.SkipLinks = SkipLinks;
//# sourceMappingURL=SkipLinks.js.map